import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@components/Buttons/Button';
import TextInput from '@components/Fields/TextInput';
import ModalContent from '@components/Modals/components/ModalContent';
import addSocialMediaAccount from '@helpers/SocialMedia/addSocialMediaAccount';
import { captureException } from '@sentry/react';
import * as React from 'react';
import { useState } from 'react';
/**
 * This is one of the steps in the add social media account modal flow
 */
const ConnectInstagramAccount = ({ existingUsername, onSuccess, onError, }) => {
    const inputFieldId = 'instagram-username-field';
    const [username, setUsername] = useState(existingUsername || '');
    const [errorMessage, setErrorMessage] = useState('');
    const [hasError, setHasError] = useState(false);
    const [loading, setLoading] = useState(false);
    const handleChange = (e) => {
        setUsername(e.target.value);
        setErrorMessage('');
        setHasError(false);
    };
    const handleAddInstagram = async () => {
        var _a, _b, _c, _d;
        if (!username) {
            setErrorMessage('Please enter a username');
            setHasError(true);
        }
        else {
            try {
                setLoading(true);
                const response = await addSocialMediaAccount('instagram', {
                    username,
                });
                if (onSuccess && response) {
                    setLoading(false);
                    onSuccess(response === null || response === void 0 ? void 0 : response.data);
                }
                else if (onError) {
                    setLoading(false);
                    onError(_jsxs(_Fragment, { children: ["We are having trouble adding your ", _jsx("span", { "data-ignore": true, children: "Instagram" }), " account. Please make sure it's a valid ", _jsx("span", { "data-ignore": true, children: "Instagram" }), " username"] }));
                }
            }
            catch (e) {
                setLoading(false);
                captureException(e, {
                    extra: {
                        component: 'ConnectInstagramAccount',
                        username,
                    },
                });
                if (onError) {
                    onError(_jsxs(_Fragment, { children: ["We are having trouble adding your ", _jsx("span", { "data-ignore": true, children: "Instagram" }), " account. Please make sure it's a valid ", _jsx("span", { "data-ignore": true, children: "Instagram" }), " username.", ' ', ((_b = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error)
                                ? `Error code: ${(_d = (_c = e === null || e === void 0 ? void 0 : e.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.error}`
                                : ''] }));
                }
            }
        }
    };
    return (_jsxs(ModalContent, { children: [_jsxs("div", { children: [_jsxs("h3", { id: "connect-instagram-heading", children: ["Connect ", _jsx("span", { "data-ignore": true, children: "Instagram" })] }), _jsxs("p", { children: ["Enter your ", _jsx("span", { "data-ignore": true, children: "Instagram" }), " username below."] }), _jsx(TextInput, { id: inputFieldId, placeholder: "Your Instagram Username", onChange: handleChange, error: hasError, errorMessage: errorMessage, value: username, "aria-labelledby": "connect-instagram-heading" })] }), _jsx(Button, { type: "button", onClick: handleAddInstagram, size: "lg", variant: "palette", paletteName: "instagram", loading: loading, children: _jsxs("span", { children: ["Connect your ", _jsx("span", { "data-ignore": true, children: "Instagram" })] }) })] }));
};
export default ConnectInstagramAccount;
